export default __webpack_public_path__ + "static/media/bfv_logo_256.5fae11bd.png";